import React, { useEffect, useRef } from 'react';

import EncounterComponent from 'components/pages/setup/Protocol/SourceDataPreview/EncounterComponent';

import Common from '../../../../../common/common';

const EpochComponent = props => {
  const componentRef = useRef(null);

  useEffect(() => {
    props.endPointHandler({ epoch: componentRef.current });
  }, [props]);

  // getting the position of epoch
  const getCurrentStyle = () => {
    if (props.epochInfo && props.epochInfo.position) {
      return {
        left: props.epochInfo.position.left ? `${props.epochInfo.position.left}px` : '400px',
        top: props.epochInfo.position.top ? `${props.epochInfo.position.top}px` : '10px'
      };
    }
    return {
      left: '400px',
      top: '10px'
    }; // this.props.epochInfo.positions
  };

  return (
    <div
      ref={componentRef}
      id={props.epochInfo ? props.epochInfo.nodeKey : ''}
      className="col-auto border mr-4 p-3 mt-3 protocol-epoch jtk-draggable jtk-endpoint-anchor"
      style={getCurrentStyle()}
    >
      <div className="col-12 p-0 d-flex justify-content-between border-bottom-p-dotted pb-2 mb-3">
        <h5 className=" col-auto p-0 c-p" id="epoch_1_title" title={props.epochInfo.name}>
          {props.epochInfo && Common.getSubString(props.epochInfo.name, 12)}
        </h5>
        <div className="d-flex flex-row col-auto p-0 justify-content-between pt-1" />
      </div>
      <div className="py-0 enscroll" id="epoc_1_encounters">
        {props.epochInfo.encounters &&
          props.epochInfo.encounters.map((vx, idx) => {
            return <EncounterComponent encDt={vx} key={idx} enId={idx} epochIdx={props.epochIdx} />;
          })}
      </div>
    </div>
  );
};

export default EpochComponent;
